import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { TokenRefreshService } from '@outlaw/core';

@Component({
  selector: 'ol-refresh-progress-bar',
  template: `
    <ol-progress-bar [progress]="$progressValue()" />
  `,
  imports: [ProgressBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshProgressBarComponent {
  $progressValue = inject(TokenRefreshService).progress;
}
